import {
  RadarEntry,
  RadarQuadrant,
  RadarRing,
  TechRadarApi,
  TechRadarLoaderResponse,
} from '@backstage-community/plugin-tech-radar';
import { toTitleCase } from '../../utils/string.utils';

const colors = [
  '#93c47d',
  '#93d2c2',
  '#fbdb84',
  '#efafa9',
  '#d685b0',
  '#cc7e63',
];

export class CustomTechRadar implements TechRadarApi {
  async load(): Promise<TechRadarLoaderResponse> {
    const iosData = require('./assets/ios-data.json');
    const androidData = require('./assets/android-data.json');
    const mergedData = [...iosData, ...androidData];

    // Need to remove duplicates from the data coming from the two files
    const data = mergedData.filter(
      (item: Record<string, string>, index: number, self: any) =>
        index ===
        self.findIndex(
          (t: any) => t.NAME.toLowerCase() === item.NAME.toLowerCase(),
        ),
    );

    const quadrants: RadarQuadrant[] = [
      ...new Set(
        data.map((item: Record<string, string>) => item.QUADRANT) as string[],
      ),
    ].map((item: string) => {
      return {
        id: item.toLowerCase(),
        name: toTitleCase(item),
      };
    });

    // Rings data
    const rings: RadarRing[] = [
      ...new Set(
        data.map((item: Record<string, string>) => item.RING) as string[],
      ),
    ].map((item: string, index: number) => {
      return {
        id: item.toLowerCase(),
        name: toTitleCase(item),
        color: colors[index],
      };
    });

    // Entries data
    const entries: RadarEntry[] = data.map((item: Record<string, string>) => ({
      id: item.NAME.toLowerCase(),
      key: item.NAME.toLowerCase(),
      title: item.NAME,
      description: item.DESCRIPTION,
      quadrant: item.QUADRANT,
      url: item.URL || '#',
      timeline: [
        {
          moved: 0,
          ringId: item.RING.toLowerCase(),
          date: item.DATE ? new Date(item.DATE) : new Date(),
        },
      ],
    }));

    return {
      quadrants,
      rings,
      entries,
    };
  }
}
